module.exports = __webpack_public_path__ + "slider-03.jpg?46bf9832f7398846be57251fecdc6f29";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-03.jpg
// module id = 266
// module chunks = 0